import React, { useEffect, useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";

const EditUser = (props) => {
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [params] = useState(props.match.params);
  const [roles, setRoles] = useState([]);
  
  

  const [registered, setRegistered] = useState(false);
  const [register, setRegister] = useState({
    id: params.id,
    firstname: "",
    lastname: "",
    userid: "",
    password: "",
    emailid: "",
    mobile_number: "",
    language: 1,
    error: "",
    city_id: 33,
    state_id: 35,
    role_id: 3,
    status: true,
    is_deleted: false,
    is_admin: false,
  });
  const [formerror, setFormError] = useState("");
  const [languages, setlanguages] = useState([]);
  const [states, setstates] = useState([]);
  const [cities, setcities] = useState([]);

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const changeData = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let check = e.target.checked;
    console.log(name, value,check);
    setRegister((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    }); 
    if (name === "is_deleted"|| name==="status") {
      setRegister((prev)=>{
          return {
            ...prev,
            name: check,
          };
      });
    }

    if (name === "email") {
      setRegister((prev) => {
        return {
          ...prev,
          username: value.split("@")[0],
        };
      });
    }
    if (name === "state_id") {
      setRegister((prev) => {
        return {
          ...prev,
          city_id: value,
        };
      });
      //console.log("state_id", value);
      getCity(value);
      if (name === "is_deleted"||name==="status") {
          this.setState({
            checked: e.target.checked,
          });
      }
    }
  };

  const removeError = (e) => {
    setFormError("");
  };

  const validate = () => {
    if (!register.firstname) {
      setFormError("Please type first name.");
      return false;
    }
    if (
      !/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        register.emailid
      )
    ) {
      setFormError("Please type a valid email address");
      return false;
    }
    if (
      !/((\+*)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/.test(
        register.mobile_number
      )
    ) {
      setFormError("Please type a valid mobile number");
      return false;
    }
    if (!/^[a-zA-Z0-9\\.|-|_]+$/.test(register.username)) {
      setFormError("Please type a valid login id");
      return false;
    }
    

    if (register.state_id === 0) {
      setFormError("Please select state.");
      return false;
    }
    if (register.city_id === 0) {
      setFormError("Please select city.");
      return false;
    }

    return true;
  };
  const getSignUp = async (e) => {
    //console.log(register, validate());
    let user = JSON.parse(localStorage.getItem("user"));
    //return;
    e.preventDefault();
    if (validate()) {
      try {
        await axios
          .put(localStorage.getItem("basurl") + "/users", register, {
            headers: { "mojo-access-tokens": user.token },
          })
          .then((response) => {
            setRegistered(true);
            setMessage(() => {
              return {
                type: "success",
                message: response.data.message,
              };
            });
            setRegister({
              firstname: "",
              lastname: "",
              userid: "",
              password: "",
              emailid: "",
              mobile_number: "",
              language: 1,
              error: "",
              city_id: 33,
              state_id: 35,
              role_id: 3,
              status: true,
              is_deleted: false,
              is_admin: false,
            });
          })
          .catch((err) => {
            setFormError(err.response.data.message);
          });
      } catch (err) {
        setFormError(err.message);
      }
    }
  };

  const getLanguage = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/languages")
        .then((response) => {
          setlanguages(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getState = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/states")
        .then((response) => {
          setstates(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getCity = async (val) => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/cities/" + val)
        .then((response) => {
          setcities(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getRoles = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/roles", {
          headers: { "mojo-access-tokens": user.token },
        })

        .then((response) => {
          console.log(response.data);
          setRoles(response.data);
        })
        .catch((err) => {
          setMessage(() => {
            return {
              type: "danger",
              message: err.response.data.message,
            };
          });
        });
    } catch (err) {
      setMessage(() => {
        return {
          type: "danger",
          message: err.message,
        };
      });
    }
  };

  const getUser = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/users/" + params.id, {
          headers: {
            "mojo-access-tokens": user.token,
          },
        })
        .then((response) => {
          response.data.forEach((value) => {
            let val = value;
            getCity(value["state_id"]);
            setRegister((prevState) => {
              return {
                ...prevState,
                ...val,
              };
            });
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };


  const handleCheck= async (e) => {
   this.setState({
    checked: e.target.checked
   })
 }

  useEffect(() => {
    getUser();
    getLanguage();
    getState();
    getCity(register.state);
    getRoles();
  }, []);

  return (
    <>
      <div className="card shadow-base bd-0 pd-20">
        {getMessage()}
        <span className="text-danger">{formerror}</span>
        <form method="post" onSubmit={getSignUp}>
          <div className="row">
            {/* firstname */}
            <div className="col-sm-6">
              <label>First Name</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-man tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-firstname"
                  type="text"
                  name="firstname"
                  value={register.firstname}
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter first name"
                  className="form-control"
                />
              </div>
            </div>
            {/* lastname */}
            <div className="col-sm-6">
              <label>Last Name</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-man tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-lastname"
                  type="text"
                  name="lastname"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter last name"
                  className="form-control"
                  value={register.lastname}
                />
              </div>
            </div>
            {/* email */}
            <div className="col-sm-6">
              <label>Mail-Id</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-email tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-email"
                  type="email"
                  name="emailid"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter email address"
                  className="form-control"
                  value={register.emailid}
                />
              </div>
            </div>
            {/* mobile */}
            <div className="col-sm-6">
              <label>Mobile</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-iphone tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-mobile_number"
                  type="phone"
                  name="mobile_number"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter mobile number"
                  className="form-control"
                  maxLength={10}
                  value={register.mobile_number}
                />
              </div>
            </div>
            {/* username */}
            <div className="col-sm-6">
              <label>User name</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-person tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-username"
                  type="text"
                  name="userid"
                  readOnly={true}
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter login id"
                  className="form-control"
                  value={register.userid}
                />
              </div>
            </div>
            {/* Role */}
            <div className="col-sm-6">
              <label>Role</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-compose tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-role"
                  name="role_id"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose Role"
                  className="form-control"
                  value={register.role_id}
                >
                  <option key={`role0`} value={0}>
                    --select--
                  </option>
                  {roles.length
                    ? roles.map((role) => (
                        <option key={`role` + role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))
                    : ""}
                </select>
              </div>
            </div>
            {/* state */}
            <div className="col-sm-6">
              <label>State</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-ios-navigate tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-state"
                  name="state_id"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose state"
                  className="form-control"
                  value={register.state_id}
                >
                  {states.map((state) => (
                    <option key={`state` + state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* city */}
            <div className="col-sm-6">
              <label>City</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-location tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-city"
                  name="city_id"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose city"
                  className="form-control"
                  value={register.city_id}
                >
                  <option key={`city0`} value={0}>
                    --select--
                  </option>
                  {cities.map((city) => (
                    <option key={`city` + city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* language */}
            <div className="col-sm-6">
              <label>Language</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="fa fa-language tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-language"
                  name="language"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose language"
                  className="form-control"
                  value={register.language}
                >
                  {languages.map((lang) => (
                    <option key={`lang` + lang.id} value={lang.id}>
                      {lang.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* <div className="col-sm-6">&nbsp;</div> */}
            {/* Active */}
            <div className="col-sm-6">
              <label>Active</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-checkmark-circled tx-16 lh-0 op-6"></i>
                </span>

                <select
                  id="signup-status"
                  name="status"
                  className="form-control"
                  onFocus={removeError}
                  onChange={changeData}
                  checked={register.status}
                >
                  <option value="1">Active</option>
                  <option value="0">In-Active</option>
                </select>
              </div>
            </div>

            {/* Deleted */}
            <div className="col-sm-6">
              <label>Deleted</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-close-circled tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-is_deleted"
                  name="is_deleted"
                  className="form-control"
                  onFocus={removeError}
                  onChange={changeData}
                  value={register.is_deleted}
                >
                  <option value="1">Deleted</option>
                  <option value="0">Not-Deleted</option>
                </select>
              </div>
            </div>
            {/* submit */}
            <div className="col-sm-6">
              <label>&nbsp;</label>
              <div className="form-group input-group">
                <button type="submit" className="btn btn-success pull-right">
                  Update User
                </button>
                &nbsp; &nbsp; &nbsp;
                <NavLink to="/admin/users"> All Users </NavLink>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default EditUser;
